module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-title top-margin"
  }, [_vm._v("Additional emails")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('SuccessAlert', {
    attrs: {
      "isVisible": _vm.isSuccessMessageDisplayed,
      "message": _vm.successMessage
    },
    on: {
      "hideSuccessAlert": _vm.hideSuccessMessage
    }
  }), _vm._v(" "), (_vm.emails.length === 0 && !_vm.shouldFormForNewEmailBeDisplayed) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.emails.length > 0 || _vm.shouldFormForNewEmailBeDisplayed) ? _c('div', {
    class: {
      'table-fixed-header--md cols-4': _vm.emails.length > 6, 'table-responsive': true, 'bottom-margin': true
    }
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [(_vm.shouldFormForNewEmailBeDisplayed) ? _c('tr', {
    class: {
      'new-email-form-shrunk': !_vm.errors.has('newEmail') && _vm.isEmailUnique(),
        'new-email-form-expanded': _vm.errors.has('newEmail') || !_vm.isEmailUnique(),
    },
    attrs: {
      "id": "newEmailRow"
    }
  }, [_c('td', {
    staticClass: "text-left column-email"
  }, [_c('div', {
    staticClass: "row margin-0"
  }, [_c('div', {
    staticClass: "row margin-0"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        email: true
      }),
      expression: "{ required: true, email: true }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newEmail),
      expression: "newEmail"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('newEmail') || !_vm.isEmailUnique()
    },
    attrs: {
      "name": "newEmail",
      "id": "newEmail",
      "type": "email",
      "required": "",
      "placeholder": "e.g., john.doe@yourinstitution.com"
    },
    domProps: {
      "value": (_vm.newEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newEmail = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row margin-0"
  }, [(_vm.errors.has('newEmail')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row margin-0"
  }, [(!_vm.isEmailUnique()) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Email cannot be a duplicate")]) : _vm._e()])])]), _vm._v(" "), _c('td', {
    staticClass: "text-left column-actions"
  }, [_c('div', {
    staticClass: "row margin-0"
  }, [_c('div', {
    staticClass: "col-lg-4 padding-0"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg button--add buttons",
    attrs: {
      "type": "button",
      "disabled": _vm.errors.has('newEmail') || !_vm.newEmail || !_vm.isEmailUnique()
    },
    on: {
      "click": _vm.addNewEmail
    }
  }, [_vm._v("\n                  Add\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 text-center padding-0"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg button--discard buttons",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideFormForNewEmail
    }
  }, [_vm._v("\n                  Discard\n                ")])])])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.emails), function(emailObj, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-left column-email"
    }, [_vm._v(_vm._s(emailObj.email))]), _vm._v(" "), _c('td', {
      staticClass: "text-left column-actions"
    }, [_c('button', {
      staticClass: "btn btn-trash",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.showQuestionModalForDeletionOfEmail(emailObj.email)
        }
      }
    }, [_c('em', {
      staticClass: "fa fa-trash fa-2x delete-icon"
    })])])])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row top-margin bottom-margin"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.displayFormForNewEmail
    }
  }, [_vm._v("\n        Add additional email\n      ")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "alert alert-info alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n        No additional emails were found.\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left column-email"
  }, [_vm._v("Email address")]), _vm._v(" "), _c('th', {
    staticClass: "text-left column-actions"
  }, [_vm._v("Actions")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5512c772","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountEmails.vue
// module id = 2149
// module chunks = 1